// import { useEffect, useState } from "react";
// import dayjs from "dayjs";
// import {
//   Button,
//   Flex,
//   message,
//   Modal,
//   Table,
//   Tag,
//   Input,
//   DatePicker,
//   TreeSelect,
//   Spin,
// } from "antd";
// import {
//   EditOutlined,
//   DeleteOutlined,
//   FolderOpenOutlined,
//   HistoryOutlined,
// } from "@ant-design/icons";
// import {
//   fetchExecutions,
//   deleteExecution,
// } from "../service/checklistExecution";
// import { useNavigate } from "react-router-dom";
// import { fetchBuilders } from "../../Configuration/ChecklistConfiguration/Service/checklistBuilder";
// import { fetchProduct } from "../../../../configuration/module/Product/Service/product";
// import { buildTreeData } from "../../../../configuration/module/Product/Component/product";
// import usePermission from "../../../../hooks/usePermission";

// const { RangePicker } = DatePicker;

// // ── Revision badge ─────────────────────────────────────────────────────────
// const RevisionBadge = ({ revisionNo }) => (
//   <Tag
//     icon={<HistoryOutlined />}
//     color={revisionNo > 1 ? "orange" : "default"}
//     style={{ fontSize: 10, padding: "0 5px", marginLeft: 4 }}
//   >
//     Rev {revisionNo}
//   </Tag>
// );

// const ChecklistExecution = () => {
//   const { canCreate, canUpdate, canDelete } = usePermission("CHECKLIST");

//   const [executions, setExecutions] = useState([]);
//   const [builders, setBuilders] = useState([]);
//   const [productList, setProductList] = useState([]);

//   const [page, setPage] = useState(1);
//   const [size, setSize] = useState(50);
//   const [total, setTotal] = useState(0);

//   const [serialNumber, setSerialNumber] = useState("");
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [dateRange, setDateRange] = useState([]);

//   const [sortField, setSortField] = useState("createdDate");
//   const [sortOrder, setSortOrder] = useState("descend");

//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const fetchData = async (
//     pageNum = page,
//     pageSize = size,
//     filters = {},
//     field = sortField,
//     order = sortOrder,
//   ) => {
//     setLoading(true);
//     try {
//       const res = await fetchExecutions({
//         page: pageNum - 1,
//         size: pageSize,
//         search: filters.serialNumber ?? serialNumber ?? "",
//         productId: filters.productId ?? selectedProduct ?? undefined,
//         fromDate: filters.fromDate ?? (dateRange?.length === 2 ? dateRange[0] : undefined),
//         toDate: filters.toDate ?? (dateRange?.length === 2 ? dateRange[1] : undefined),
//         sort: field,
//         desc: order === "descend",
//       });

//       setExecutions(res.data?.content || []);
//       setTotal(res.data?.totalElements || 0);
//       setPage(pageNum);
//       setSize(pageSize);
//       setSortField(field);
//       setSortOrder(order);
//     } catch {
//       message.error("Error fetching executions");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchBuilders()
//       .then((res) => setBuilders(res.data || []))
//       .catch(() => message.error("Error fetching builders"));
//     fetchProduct()
//       .then((res) => setProductList(buildTreeData(res.data)))
//       .catch(() => message.error("Error fetching products"));
//   }, []);

//   const deleteData = async (id) => {
//     try {
//       await deleteExecution(id);
//       message.success("Execution deleted successfully");
//       fetchData(page, size);
//     } catch {
//       message.error("Error deleting execution");
//     }
//   };

//   // ── Edit: ask Edit-in-place vs New Revision ───────────────────────────────
//   const handleEdit = (record) => {
//     Modal.confirm({
//       title: "How do you want to edit this execution?",
//       icon: <EditOutlined style={{ color: "#1677ff" }} />,
//       width: 460,
//       content: (
//         <div style={{ fontSize: 13 }}>
//           <p>
//             <strong>{record.checklist?.checklistName}</strong> — Serial:{" "}
//             <strong>{record.serialNumber}</strong>{" "}
//             <RevisionBadge revisionNo={record.revisionNo || 1} />
//           </p>
//           <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
//             <div style={{
//               padding: "10px 14px", borderRadius: 6,
//               border: "1px solid #d9d9d9", background: "#f0f5ff",
//             }}>
//               <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
//                 <EditOutlined style={{ marginRight: 6 }} />
//                 Edit existing (Rev {record.revisionNo || 1})
//               </div>
//               <div style={{ fontSize: 12, color: "#666" }}>
//                 Correct a data entry mistake. Same revision number, same record.
//               </div>
//             </div>
//             <div style={{
//               padding: "10px 14px", borderRadius: 6,
//               border: "1px solid #d9d9d9", background: "#fff7e6",
//             }}>
//               <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
//                 <HistoryOutlined style={{ marginRight: 6 }} />
//                 New revision (Rev {(record.revisionNo || 1) + 1})
//               </div>
//               <div style={{ fontSize: 12, color: "#666" }}>
//                 Product is being re-inspected. Creates a new record, preserves old one.
//               </div>
//             </div>
//           </div>
//         </div>
//       ),
//       okText: "New revision",
//       cancelText: "Edit existing",
//       onOk:    () => navigate(`edit/${record.id}`, { state: { revisionMode: "REVISION" } }),
//       onCancel: () => navigate(`edit/${record.id}`, { state: { revisionMode: "EDIT" } }),
//     });
//   };

//   const applyFilters = () => fetchData(1, size);

//   const resetFilters = () => {
//     setSerialNumber("");
//     setSelectedProduct(null);
//     setDateRange([]);
//     fetchData(1, size, {
//       serialNumber: "",
//       productId: undefined,
//       fromDate: undefined,
//       toDate: undefined,
//     }, sortField, sortOrder);
//   };

//   const columns = [
//     {
//       title: "Serial Number",
//       dataIndex: "serialNumber",
//       key: "serialNumber",
//       sorter: true,
//       sortOrder: sortField === "serialNumber" ? sortOrder : null,
//       render: (val, record) => (
//         <span>
//           {val}
//           <RevisionBadge revisionNo={record.revisionNo || 1} />
//         </span>
//       ),
//     },
//     {
//       title: "PO Number",
//       dataIndex: "poNumber",
//       key: "poNumber",
//     },
//     {
//       title: "Model Number",
//       dataIndex: "modelNumber",
//       key: "modelNumber",
//     },
//     {
//       title: "Product",
//       dataIndex: ["product", "productName"],
//       key: "product",
//     },
//     {
//       title: "Checklist",
//       dataIndex: ["checklist", "checklistName"],
//       key: "checklist",
//     },
//     {
//       title: "Created At",
//       dataIndex: "createdDate",
//       key: "createdDate",
//       sorter: true,
//       sortOrder: sortField === "createdDate" ? sortOrder : null,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
//     },
//     {
//       title: "Updated At",
//       dataIndex: "updatedDate",
//       key: "updatedDate",
//       sorter: true,
//       render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       align: "center",
//       render: (_, record) => (
//         <>
//           <FolderOpenOutlined
//             style={{ marginRight: 12, cursor: "pointer" }}
//             onClick={() => navigate(`view/${record.id}`)}
//           />
//           {canUpdate && (
//             <EditOutlined
//               style={{ marginRight: 12, cursor: "pointer" }}
//               onClick={() => handleEdit(record)}
//             />
//           )}
//           {canDelete && (
//             <DeleteOutlined
//               style={{ cursor: "pointer" }}
//               onClick={() => deleteData(record.id)}
//             />
//           )}
//         </>
//       ),
//     },
//   ];

//   return (
//     <Spin spinning={loading}>
//       <div>
//         <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
//           <div style={{ fontSize: "1rem", fontWeight: 700 }}>Checklist Execution</div>
//         </Flex>

//         <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
//           <Input
//             placeholder="Search serial number"
//             value={serialNumber}
//             onChange={(e) => setSerialNumber(e.target.value)}
//             style={{ width: 200 }}
//           />
//           <TreeSelect
//             value={selectedProduct}
//             onChange={setSelectedProduct}
//             treeData={productList}
//             placeholder="Select product"
//             allowClear
//             style={{ width: 220 }}
//           />
//           <RangePicker value={dateRange} onChange={setDateRange} style={{ width: 260 }} />
//           <Button type="primary" onClick={applyFilters}>Apply</Button>
//           <Button onClick={resetFilters}>Reset</Button>

//           {canCreate && (
//             <Flex flex={1} justify="end">
//               <Button
//                 type="primary"
//                 style={{ fontWeight: 600 }}
//                 onClick={() => navigate("add")}
//               >
//                 + Add
//               </Button>
//             </Flex>
//           )}
//         </Flex>

//         <Table
//           rowKey="id"
//           columns={columns}
//           dataSource={executions}
//           bordered
//           scroll={{ x: "max-content" }}
//           pagination={{
//             current: page,
//             pageSize: size,
//             total,
//             showSizeChanger: true,
//             pageSizeOptions: ["10", "20", "50", "100"],
//           }}
//           onChange={(pagination, filters, sorter) => {
//             fetchData(
//               pagination.current,
//               pagination.pageSize,
//               {},
//               sorter.field || sortField,
//               sorter.order || sortOrder,
//             );
//           }}
//         />
//       </div>
//     </Spin>
//   );
// };

// export default ChecklistExecution;

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Button,
  Flex,
  message,
  Modal,
  Table,
  Tag,
  Input,
  DatePicker,
  Spin,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  FolderOpenOutlined,
  HistoryOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  fetchExecutions,
  deleteExecution,
} from "../service/checklistExecution";
import { useNavigate } from "react-router-dom";
import usePermission from "../../../../hooks/usePermission";

const { RangePicker } = DatePicker;

// ── Revision badge (execution revision, i.e. re-inspection count) ───────────
const RevisionBadge = ({ revisionNo }) => (
  <Tag
    icon={<HistoryOutlined />}
    color={revisionNo > 1 ? "orange" : "default"}
    style={{ fontSize: 10, padding: "0 5px", marginLeft: 4 }}
  >
    Rev {revisionNo}
  </Tag>
);

// ── Checklist version badge (template revision used for this execution) ─────
const ChecklistVersionBadge = ({ revisionNo }) => (
  <Tag
    color="blue"
    style={{ fontSize: 10, padding: "0 5px", marginLeft: 4 }}
    icon={<HistoryOutlined />}
  >
    Rev {revisionNo || 1}
  </Tag>
);

let searchTimeout = null;

const ChecklistExecution = () => {
  const { canCreate, canUpdate, canDelete } = usePermission("CHECKLIST");

  const [executions, setExecutions] = useState([]);

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [total, setTotal] = useState(0);

  const [search, setSearch] = useState("");
  const [dateRange, setDateRange] = useState([]);

  const [sortField, setSortField] = useState("createdDate");
  const [sortOrder, setSortOrder] = useState("descend");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const fetchData = async (
    pageNum = page,
    pageSize = size,
    searchText = search,
    range = dateRange,
    field = sortField,
    order = sortOrder,
  ) => {
    setLoading(true);
    try {
      const res = await fetchExecutions({
        page: pageNum - 1,
        size: pageSize,
        search: searchText || "",
        fromDate: range?.length === 2 ? range[0] : undefined,
        toDate: range?.length === 2 ? range[1] : undefined,
        sort: field,
        desc: order === "descend",
        allRevisions: true,
      });

      setExecutions(res.data?.content || []);
      setTotal(res.data?.totalElements || 0);
      setPage(pageNum);
      setSize(pageSize);
      setSortField(field);
      setSortOrder(order);
    } catch {
      message.error("Error fetching executions");
    } finally {
      setLoading(false);
    }
  };

  // ── Search (debounced), same pattern as User list ───────────────────────
  useEffect(() => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(
      () => fetchData(1, size, search, dateRange),
      500,
    );
    return () => clearTimeout(searchTimeout);
  }, [search]);

  useEffect(() => {
    fetchData();
  }, []);

  const deleteData = async (id) => {
    try {
      await deleteExecution(id);
      message.success("Execution deleted successfully");
      fetchData(page, size);
    } catch {
      message.error("Error deleting execution");
    }
  };

  // ── Date range: applied immediately on change ─────────────────────────────
  const handleDateRangeChange = (range) => {
    setDateRange(range || []);
    fetchData(1, size, search, range || []);
  };

  // ── Edit: ask Edit-in-place vs New Revision ───────────────────────────────
  const handleEdit = (record) => {
    Modal.confirm({
      title: "How do you want to edit this execution?",
      icon: <EditOutlined style={{ color: "#1677ff" }} />,
      width: 460,
      closable: true,
      content: (
        <div style={{ fontSize: 13 }}>
          <p>
            <strong>{record.checklist?.checklistName}</strong> — Serial:{" "}
            <strong>{record.serialNumber}</strong>{" "}
            <RevisionBadge revisionNo={record.revisionNo || 1} />
          </p>
          <div
            style={{
              marginTop: 12,
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div
              style={{
                padding: "10px 14px",
                borderRadius: 6,
                border: "1px solid #d9d9d9",
                background: "#f0f5ff",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
                <EditOutlined style={{ marginRight: 6 }} />
                Edit existing (Rev {record.revisionNo || 1})
              </div>
              <div style={{ fontSize: 12, color: "#666" }}>
                Correct a data entry mistake. Same revision number, same record.
              </div>
            </div>
            <div
              style={{
                padding: "10px 14px",
                borderRadius: 6,
                border: "1px solid #d9d9d9",
                background: "#fff7e6",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3 }}>
                <HistoryOutlined style={{ marginRight: 6 }} />
                New revision (Rev {(record.revisionNo || 1) + 1})
              </div>
              <div style={{ fontSize: 12, color: "#666" }}>
                Product is being re-inspected. Creates a new record, preserves
                old one.
              </div>
            </div>
          </div>
        </div>
      ),
      okText: "New revision",
      cancelText: "Edit existing",
      footer: (_, { OkBtn }) => (
        <>
          <Button onClick={() => Modal.destroyAll()}>Cancel</Button>
          <Button
            onClick={() => {
              Modal.destroyAll();
              navigate(`edit/${record.id}`, { state: { revisionMode: "EDIT" } });
            }}
          >
            Edit existing
          </Button>
          <OkBtn />
        </>
      ),
      onOk: () =>
        navigate(`edit/${record.id}`, { state: { revisionMode: "REVISION" } }),
      // × icon / backdrop click: just close, no navigation
      onCancel: () => {},
    });
  };

  const columns = [
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      sorter: true,
      sortOrder: sortField === "serialNumber" ? sortOrder : null,
      render: (val, record) => (
        <span>
          {val}
          <RevisionBadge revisionNo={record.revisionNo || 1} />
        </span>
      ),
    },
    {
      title: "PO Number",
      dataIndex: "poNumber",
      key: "poNumber",
      sorter: true,
      sortOrder: sortField === "poNumber" ? sortOrder : null,
    },
    {
      title: "Model Number",
      dataIndex: "modelNumber",
      key: "modelNumber",
      sorter: true,
      sortOrder: sortField === "modelNumber" ? sortOrder : null,
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      key: "product",
      sorter: true,
      sortOrder: sortField === "product" ? sortOrder : null,
    },
    {
      title: "Checklist",
      dataIndex: ["checklist", "checklistName"],
      key: "checklist",
      sorter: true,
      sortOrder: sortField === "checklist" ? sortOrder : null,
      render: (val, record) => (
        <span>
          {val}
          <ChecklistVersionBadge revisionNo={record.checklist?.revisionNo} />
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdDate",
      key: "createdDate",
      sorter: true,
      sortOrder: sortField === "createdDate" ? sortOrder : null,
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
    },
    {
      title: "Updated At",
      dataIndex: "updatedDate",
      key: "updatedDate",
      sorter: true,
      render: (val) => (val ? dayjs(val).format("DD MMM YYYY HH:mm") : "-"),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <>
          <FolderOpenOutlined
            style={{ marginRight: 12, cursor: "pointer" }}
            onClick={() => navigate(`view/${record.id}`)}
          />
          {canUpdate && (
            <EditOutlined
              style={{ marginRight: 12, cursor: "pointer" }}
              onClick={() => handleEdit(record)}
            />
          )}
          {canDelete && (
            <DeleteOutlined
              style={{ cursor: "pointer" }}
              onClick={() => deleteData(record.id)}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div>
        <div style={{ fontSize: "1rem", marginBottom: 16, fontWeight: 700 }}>
          Checklist Execution
        </div>

        <Flex gap={12} style={{ marginBottom: 16, flexWrap: "wrap" }}>
          <Input
            placeholder="Search PO No, Model No, Serial No, Product, Checklist"
            prefix={<SearchOutlined />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 320 }}
            allowClear
          />
          <RangePicker
            value={dateRange}
            onChange={handleDateRangeChange}
            style={{ width: 320 }}
          />
          <Flex justify="end" align="center" flex={1}>
            {canCreate && (
              <Button
                type="primary"
                style={{ fontWeight: 600 }}
                onClick={() => navigate("add")}
              >
                + Add
              </Button>
            )}
          </Flex>
        </Flex>

        <Table
          rowKey="id"
          columns={columns}
          size="small"
          dataSource={executions}
          bordered
          scroll={{ x: "max-content" }}
          pagination={{
            current: page,
            pageSize: size,
            total,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
          }}
          onChange={(pagination, _, sorter) => {
            fetchData(
              pagination.current,
              pagination.pageSize,
              search,
              dateRange,
              sorter.columnKey || sortField,
              sorter.order || sortOrder,
            );
          }}
        />
      </div>
    </Spin>
  );
};

export default ChecklistExecution;